import { render, staticRenderFns } from "./Productsinoperation.vue?vue&type=template&id=4d8d9df0"
import script from "./Productsinoperation.vue?vue&type=script&lang=js"
export * from "./Productsinoperation.vue?vue&type=script&lang=js"
import style0 from "./Productsinoperation.vue?vue&type=style&index=0&id=4d8d9df0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports